// AI-CONTEXT: See docs/features/updates-log.md

import formatUpdateDate from '../../helpers/updates/formatUpdateDate'
import { UPDATE_MODULES } from '../../helpers/updates/updateModules'

/**
 * @typedef {object} Update
 * @property {string} id - Uniek id, begint met de datum
 * @property {string} date - ISO-datum van de update
 * @property {Array<string>} modules - Codes uit UPDATE_MODULES
 * @property {string} title - Korte kop in lekentaal
 * @property {string} body - Uitleg van wat de gebruiker eraan heeft
 * @property {Array<string>} [bullets] - Optionele opsomming
 */

/**
 * Eén update in de lijst op de Updates-pagina.
 *
 * @param {object} props
 * @param {Update} props.update - De update die getoond wordt
 * @param {string} [props.hideModule] - Categorie die niet als label getoond hoeft te
 *   worden; op een categorie-tabblad staat die immers al boven de lijst
 * @param {Array<string>} [props.visibleModules] - Categorieën die deze organisatie
 *   afneemt; alleen daarvan wordt een label getoond
 */
const UpdateItem = ({ update, hideModule, visibleModules }) => {

  // Hooks
  const datum = formatUpdateDate(update.date)

  // Een update kan bij twee categorieën horen en komt in de lijst zodra ÉÉN
  // daarvan aanstaat. Het label van de andere zou dan verwijzen naar een
  // onderdeel dat deze organisatie niet eens heeft.
  // AI-CONTEXT: See docs/features/update-aanvragen.md
  const labels = update.modules
    .filter(slug => slug !== hideModule)
    .filter(slug => !Array.isArray(visibleModules) || visibleModules.includes(slug))

  // JSX
  return (
    <article className="update-item" id={update.id}>
      <div className="update-item-date">{datum}</div>
      <div className="update-item-content">
        <h3>{update.title}</h3>
        <p className="update-item-body">{update.body}</p>
        {update.bullets &&
          <ul className="update-item-bullets">
            {update.bullets.map(bullet => <li key={bullet}>{bullet}</li>)}
          </ul>
        }
        {labels.length > 0 &&
          <div className="update-item-modules">
            {labels.map(slug => (
              <span key={slug} className="update-item-module">
                {UPDATE_MODULES[slug].label}
              </span>
            ))}
          </div>
        }
      </div>
    </article>
  )
}

export default UpdateItem
